import React, { useState, useRef, useContext } from "react";
import Categories from "../../components/Products/Categories/Categories";
import ProductCard from "../../components/Products/ProductCard";
import * as styles from "../../components/Products/Product.module.scss";
import { AppContext } from "../../context/AppContext";
import Loader from "../Loader/Loader";

const Products = ({
  products,
  category,
  color,
  allCategories,
  parentCategory,
  setCountry,
  countryOn,
}) => {
  const groupProductsById = (products) => {
    return products?.reduce((acc, product) => {
      if (!acc[product.productId]) {
        acc[product.productId] = [];
      }
      acc[product.productId].push(product);
      return acc;
    }, {});
  };

  const categoriesContainerRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const { country } = useContext(AppContext);

  setCountry(country);

  const onDragStart = (e) => {
    e.preventDefault();
    setIsDragging(true);
    setStartX(e.clientX - categoriesContainerRef.current.offsetLeft);
    categoriesContainerRef.current.style.cursor = "grabbing";
  };

  const onDragEnd = () => {
    setIsDragging(false);
    categoriesContainerRef.current.style.cursor = "grab";
  };

  const onDragMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.clientX - categoriesContainerRef.current.offsetLeft;
    const walk = (x - startX) * 0.5;
    categoriesContainerRef.current.scrollLeft -= walk;
    setStartX(x);
  };

  const groupedProducts = groupProductsById(products);

  const colorStyles = {
    lightblue: styles.color_lightblue,
    red: styles.color_red,
    orange: styles.color_orange,
    yellow: styles.color_yellow,
    green: styles.color_green,
    blue: styles.color_blue,
    white: styles.color_white,
    black: styles.color_black,
  };

  const colorSelected = colorStyles[color];

  const formatCategory = (category) => {
    return category
      .split(' ') // Divide la categoría en palabras
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Convierte la primera letra a mayúscula
      .join(' '); // Une las palabras nuevamente
  };

  return (
    <div>
      {Object?.keys(groupedProducts).length === 0 ? (
        <>
          <Loader />
        </>
      ) : (
        <div className={styles.container}>
          <div className={styles.container_allCategories}>
            <div className={styles.text}>
              <h4 className={colorSelected}>{parentCategory}</h4>
            </div>
            <div
              className={styles.container_categories}
              ref={categoriesContainerRef}
              onMouseDown={onDragStart}
              onMouseMove={isDragging ? onDragMove : null}
              onMouseUp={onDragEnd}
              onMouseLeave={onDragEnd}
            >
              <Categories
                category={category}
                allCategories={allCategories}
                color={colorSelected}
                title={category}
                parentCategory={parentCategory}
              />
            </div>
          </div>
          <div className="section">
            <h2
              className={`${styles.products__title} ${colorSelected} section`}
            >
              {formatCategory(category)}
            </h2>
            <div className="container flex-col align-center">
              <div className={`${styles.products__container}`}>
                {Object.values(groupedProducts)
                .reverse() // Invertir el orden de los grupos de productos
                .map((productGroup) => (
                  <ProductCard
                    key={productGroup[0].productId}
                    productGroup={productGroup}
                    category={category}
                    color={color}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Products;
